export default "__VITE_ASSET__CNA$z_cp__"